import { useContext, useEffect, FC } from "react";
import { LayoutContext } from "../../../Layouts/Dashboard/dashboard";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";

const SelectModeBannerOpener: FC<{
  selectedObjects: DbAssetObjectInfos[] | number[];
}> = (props) => {
  const { selectedObjects } = props;
  const layoutContext = useContext(LayoutContext);
  const { setVisibleBanner } = layoutContext;

  useEffect(() => {
    if (selectedObjects && selectedObjects.length > 0) {
      setVisibleBanner(true);
    } else {
      setVisibleBanner(false);
    }
  }, [selectedObjects, setVisibleBanner]);

  return null;
};

export default SelectModeBannerOpener;
